import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Sidebar from "./Sidebar";
import "../CSS/project.css";
import { Link } from "react-router-dom";
import { BASE_API_URL } from "../constants";
const API_BASE_URL = "/api";

const ProjectsPage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loggedInUserId, setLoggedInUserId] = useState(null);

  useEffect(() => {
    const userId = sessionStorage.getItem("userId");
    if (userId) {
      setLoggedInUserId(userId);
    } else {
      setError(
        "User ID not found. Please log in to view your contributed projects."
      );
      setLoading(false);
    }
  }, []);

  const fetchContributedProjects = useCallback(async () => {
    if (!loggedInUserId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${BASE_API_URL}${API_BASE_URL}/projects/contributed/${loggedInUserId}`
      );
	  console.log("API Response:", response.data);
      setProjects(response.data);
	  if (Array.isArray(response.data)) {
		setProjects(response.data);
	  } else {
		console.error("Expected array but got:", response.data);
		setProjects([]);
	  }
    } catch (err) {
      console.error("Error fetching contributed projects:", err);
      const detail =
        err.response?.data?.detail || "An unexpected error occurred.";
      setError(`Failed to load projects: ${detail}`);
      setProjects([]);
    } finally {
      setLoading(false);
    }
  }, [loggedInUserId]);

  useEffect(() => {
    if (loggedInUserId) {
      fetchContributedProjects();
    }
  }, [loggedInUserId, fetchContributedProjects]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <>
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <main className="pj-main-content">
        <div className="pj-page-header">
          <h1 className="pj-page-title">
            <i className="fas fa-hand-holding-heart"></i> Your Contributed
            Projects
          </h1>
        </div>

        {loading && <p className="pj-loading"> Loading your projects...</p>}
        {error && <p className="pj-error"> {error}</p>}

        {!loading && !error && (
          <div className="discover-grid">
            {projects.length > 0 ? (
              projects.map((project) => (
                <div key={project.ProjectID} className="project-card-modern">
                  <div className="project-glow-border"></div>
                  <div className="project-content">
                    <h3 className="project-title-modern">{project.title}</h3>
                    <span className="stage-tag">{project.stage || "N/A"}</span>

                    <div className="project-meta">
                      <p>
                        <strong>Project ID:</strong> {project.ProjectID}
                      </p>
                      <p>
                        <strong>Status:</strong>
                        <span className="status-tag">
                          {" "}
                          Contributed Successfully
                        </span>
                      </p>
                      <p>
                        <strong>Category:</strong>{" "}
                        {project.category || "Film / Media"}
                      </p>
                    </div>

                    <p className="project-description">
                      {project.aboutProject
                        ? project.aboutProject.substring(0, 150) + "..."
                        : "No description provided for this project."}
                    </p>

                    {/*  Correct funding progress calculation */}
                    <div className="funding-bar">
                      <div
                        className="funding-fill"
                        style={{
                          width: `${project.progressPercent ?? 0}%`,
                        }}
                      ></div>
                    </div>

                    <p className="funding-info">
                      Funding Progress: {project.progressPercent ?? 0}%
                    </p>

                    <div className="project-footer">
                      <Link to={`/project/contributed/${project.ProjectID}`}>
                        <button className="view-details-btn">
                          <i className="fas fa-eye"></i> View Details
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="pj-empty">
                You havent contributed to any projects yet.
              </p>
            )}
          </div>
        )}
      </main>
    </>
  );
};

export default ProjectsPage;





